import React from "react";
import AdminTemplate from "../../../components/admin/layouts/Template.js";
import ContentWrapper from "../../../components/common/AssessmentContentWrapper.js";
import Card from "../../../components/common/Card.js";
import CardBody from "../../../components/common/CardBody.js";
import TabList from "../../../components/common/tabs/TabList.js";
import NavItem from "../../../components/common/tabs/NavItem.js";
import TabContent from "../../../components/common/tabs/TabContent.js";
import TabPane from "../../../components/common/tabs/TabPane.js";
import StickyCardBody from "../../../components/common/StickyCardBody.js";
import ManagePassageTypes from "./ManagePassageTypes.js";
import ManagePassages from "./ManagePassages.js";
import "./Passage.css";

class Passage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "Passage Types",
    };
  }

  render() {
    return (
      <AdminTemplate>
        <ContentWrapper>
          <Card>
            <CardBody>
              <div className="passage-wrapper">
                <div className="col-md-12 px-0">
                  <StickyCardBody>
                    {/* Navigation Tabs (primary) - hide when tabs are shown in-grid on both tab pages */}
                    <div className="d-flex align-items-center justify-content-start w-100 mb-3 main-nav-hidden">
                      <TabList>
                        <NavItem
                          className={`nav-link ${this.state.activeTab === 'Passage Types' ? 'active' : ''}`}
                          id="passage-types-tab-1"
                          href="#passage-types-1"
                          dataToggle="tab"
                          iconName="flaticon2-list-2"
                          tabName="Passage Types"
                          onClick={() => {
                            this.setState({
                              activeTab: "Passage Types",
                            });
                          }}
                        />
                        <NavItem
                          className={`nav-link ${this.state.activeTab === 'Passages' ? 'active' : ''}`}
                          id="passages-tab-1"
                          href="#passages-1"
                          dataToggle="tab"
                          iconName="flaticon2-file"
                          tabName="Passages"
                          onClick={() => {
                            this.setState({
                              activeTab: "Passages",
                            });
                          }}
                        />
                      </TabList>
                    </div>
                  </StickyCardBody>

                  {/* Tab Content */}
                  <TabContent>
                    <TabPane
                      className="tab-pane fade show active"
                      id="passage-types-1"
                      ariaLabelledby="passage-types-tab-1"
                    >
                      <ManagePassageTypes
                        activeTab={this.state.activeTab}
                        setActiveTab={(tabName) => this.setState({ activeTab: tabName })}
                      />
                    </TabPane>

                    <TabPane
                      className="tab-pane fade"
                      id="passages-1"
                      ariaLabelledby="passages-tab-1"
                    >
                      <ManagePassages
                        activeTab={this.state.activeTab}
                        setActiveTab={(tabName) => this.setState({ activeTab: tabName })}
                      />
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </CardBody>
          </Card>
        </ContentWrapper>
      </AdminTemplate>
    );
  }
}

export default Passage;
